import { useEffect, useState } from "react";
import axios from "axios";

const useRecoleccionesMes = (year, token, id_punto_generacion) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `https://seguimientoconductor-nodejs-pits.com/punto_seginus/obtenerRecoleccionesPorMes`,
          {anio: year === "acumulado" ? "all" : year, 
            id_punto_generacion: id_punto_generacion},
          {headers: { Authorization: token }}
        );
         
        setData(response.data || []);
      } catch (error) {
        console.error("Error   data", error);
        setData([]);  
      }
    };

    if (token && id_punto_generacion) { 
      fetchData();
    }
  }, [year, token, id_punto_generacion]);

  return data;
};

export default useRecoleccionesMes;